// extracted by mini-css-extract-plugin
export default {"contentWrapper":"jQI91Q","noPadding":"XYYYOX","notifications":"CztxjB"};